/**
 * Layout: FAQ - Lijst
 * Slug: faq_overview
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.faq_overview-layout');

	layouts.forEach((layout) => {
		
	});
});
